<template>
    <article class="product">
        <div class="product__picture">
            <div
                :style="{ backgroundImage: 'url(' + product.image + ')' }"
                class="product__img"
                @click="productPopup"
            ></div>
            <!--<div class="product__video video">
        <div class="video__text">Смотреть видео</div>
        <div class="video__btn">
          <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.95459 2.13399C4.62126 2.51889 4.62126 3.48114 3.95459 3.86604L1.77277 5.12572C1.10611 5.51062 0.272771 5.02949 0.272771 4.25969L0.272771 1.74034C0.272771 0.970544 1.1061 0.489418 1.77277 0.874318L3.95459 2.13399Z" fill="#373737" />
          </svg>
        </div>
      </div>-->
        </div>
        <div class="product__body">
            <div class="product__content">
                <div class="product__name">{{ product.real_name }}</div>
                <div class="product__text">
                    {{
                        product.description.length > 45
                            ? product.description.substr(0, 68) + "..."
                            : product.description
                    }}
                </div>
                <!--      <div class="product__modifiers modifiers">-->
                <!--        <div class="modifiers__item modifier">-->
                <!--          <div class="modifier__icon">-->
                <!--            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--              <path-->
                <!--                d="M12.4241 2.05831C12.6574 2.31766 12.8224 2.59561 12.8726 2.93287C12.9147 3.21819 12.8631 3.48315 12.6964 3.71899C12.6466 3.78953 12.6448 3.84217 12.675 3.92008C13.008 4.77674 12.9586 5.61409 12.4911 6.40513C12.0619 7.13158 11.6439 7.87067 11.1452 8.5487C9.81478 10.3582 8.0204 11.4598 5.81155 11.8746C5.02437 12.0224 4.22913 12.0778 3.43424 11.9518C2.40281 11.7883 1.53983 11.3029 0.848471 10.5196C0.802848 10.4677 0.778633 10.3663 0.793373 10.2985C0.814429 10.2024 0.911641 10.1845 1.00745 10.1918C1.49632 10.229 1.98448 10.2785 2.47405 10.2985C4.67624 10.3884 6.59731 8.85753 6.99037 6.68729C7.10864 6.03382 7.1855 5.37194 7.26271 4.71181C7.40133 3.52421 8.18499 2.58824 9.33364 2.2573C9.37645 2.24501 9.43015 2.20852 9.44524 2.17026C9.64668 1.65893 10.0527 1.43257 10.5676 1.3687C10.7308 1.34835 10.9003 1.35817 11.0649 1.37502C11.1477 1.38344 11.1901 1.36379 11.2379 1.30132C11.5558 0.886152 11.9177 0.512746 12.3216 0.1804C12.6438 -0.0845638 13.0754 -0.0554353 13.3309 0.250589C13.5896 0.560124 13.5422 0.998455 13.2116 1.26237C12.9196 1.49539 12.6501 1.74878 12.4241 2.05901V2.05831ZM1.44683 10.6059C1.46333 10.6245 1.47351 10.6386 1.48614 10.6495C2.0473 11.1362 2.69164 11.4549 3.42371 11.5823C4.1077 11.7009 4.79451 11.6651 5.47604 11.5598C7.7256 11.2117 9.54491 10.129 10.8831 8.2897C11.3856 7.59869 11.7983 6.84135 12.2412 6.10787C12.4104 5.82747 12.4858 5.50951 12.5146 5.18419C12.6599 3.53544 11.1115 2.19693 9.50315 2.59491C8.57805 2.82372 7.95863 3.41121 7.71648 4.33244C7.58523 4.83254 7.54803 5.3579 7.47608 5.87274C7.39466 6.45707 7.32482 7.04139 7.11426 7.60115C6.44957 9.36816 4.70466 10.6238 2.81868 10.6607C2.36491 10.6695 1.91043 10.6256 1.44683 10.6056V10.6059ZM12.4279 3.42875C12.4399 3.4277 12.4521 3.4263 12.4641 3.42524C12.483 3.3333 12.5143 3.2417 12.5185 3.14905C12.5346 2.78968 12.3581 2.51384 12.1187 2.26888C11.9787 2.12604 11.9728 2.07551 12.0879 1.90846C12.3279 1.55927 12.6209 1.26202 12.9529 0.999157C13.0263 0.9409 13.0916 0.850356 13.12 0.761917C13.1642 0.624347 13.0912 0.48818 12.9705 0.414481C12.8382 0.333764 12.6904 0.346398 12.5578 0.456945C12.1528 0.794555 11.786 1.17007 11.4741 1.59471C11.3688 1.73755 11.2638 1.78422 11.0866 1.74667C10.7722 1.67999 10.456 1.69754 10.1703 1.86319C10.0548 1.92987 9.95972 2.03129 9.85514 2.11692C9.86251 2.1299 9.86988 2.14289 9.87725 2.15587C10.3833 2.13622 10.8673 2.22396 11.321 2.44962C11.7769 2.67633 12.1433 3.00692 12.4283 3.42911L12.4279 3.42875Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--              <path d="M10.3876 3.22125V3.56729C9.50915 3.64484 8.96203 4.10528 8.74935 4.97177C8.63845 4.95492 8.52826 4.93808 8.41876 4.92158C8.46754 4.1488 9.27086 3.20757 10.3876 3.2216V3.22125Z" fill="#373737" />-->
                <!--            </svg>-->
                <!--          </div>-->
                <!--          <div class="modifier__name">Острое</div>-->
                <!--        </div>-->
                <!--        <div class="modifiers__item modifier">-->
                <!--          <div class="modifier__icon">-->
                <!--            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--              <path-->
                <!--                d="M0.444885 9.53366C0.488393 9.19658 0.522955 8.85828 0.577034 8.52282C0.80555 7.10456 1.17557 5.73509 1.96683 4.51038C2.39093 3.8541 2.95002 3.33933 3.58515 2.89287C4.75863 2.06826 5.99392 1.36523 7.36054 0.911454C8.47628 0.541031 9.61886 0.367001 10.7948 0.470687C12.0146 0.578032 13.1336 0.965533 14.1347 1.68483C14.9276 2.25409 15.6436 2.89857 16.1889 3.71464C16.8439 4.69498 17.1782 5.76599 17.0318 6.95289C16.8846 8.14508 16.306 9.08923 15.3252 9.78006C14.2331 10.5494 13.012 10.9243 11.6788 10.9609C11.0522 10.9779 10.4244 11.0019 9.80143 11.0641C9.22851 11.1211 8.68731 11.2931 8.28355 11.7448C7.98916 12.0742 7.82408 12.4735 7.68258 12.8837C7.60695 13.1033 7.53457 13.3241 7.46829 13.5465C7.15683 14.5903 6.44038 15.1758 5.384 15.3352C4.44391 15.4771 3.54164 15.3141 2.69548 14.8761C2.26935 14.6557 1.9835 14.2845 1.71595 13.9015C1.09668 13.0147 0.699018 12.0368 0.528241 10.9678C0.496932 10.7718 0.472535 10.5746 0.444885 10.3778C0.444885 10.0964 0.444885 9.81503 0.444885 9.53366ZM10.2186 0.983018C9.34521 0.980171 8.5145 1.14322 7.7025 1.40305C6.30497 1.85032 5.0457 2.56148 3.84172 3.39219C2.92725 4.02325 2.29863 4.86006 1.86925 5.86643C1.46548 6.81261 1.24306 7.80596 1.0914 8.81965C0.987305 9.51495 0.966568 10.2094 1.0792 10.9035C1.2329 11.8505 1.57771 12.7247 2.12541 13.514C2.34051 13.8242 2.55276 14.143 2.89269 14.3362C3.63272 14.7566 4.42805 14.9026 5.26933 14.7883C6.12322 14.6724 6.69248 14.2199 6.94457 13.3786C7.05761 13.0016 7.19261 12.63 7.34143 12.2657C7.72852 11.3162 8.42464 10.7478 9.4432 10.562C10.1719 10.429 10.905 10.4136 11.6405 10.4058C12.6331 10.3953 13.565 10.1497 14.4372 9.68044C15.0496 9.35109 15.5989 8.93756 15.9681 8.33578C16.7272 7.09887 16.6923 5.83634 16.0352 4.57259C15.5542 3.64754 14.8438 2.9193 14.0253 2.28905C12.8994 1.42175 11.6308 0.969599 10.2194 0.983424L10.2186 0.983018Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--              <path-->
                <!--                d="M10.1864 1.54085C11.4099 1.52905 12.5151 1.88199 13.5089 2.59966C14.1399 3.05547 14.7267 3.55561 15.1808 4.19277C15.9111 5.21702 16.1815 6.32545 15.7452 7.5465C15.5407 8.11942 15.1357 8.54067 14.6453 8.87328C13.9508 9.34413 13.1803 9.58078 12.3333 9.53402C11.7128 9.49987 11.1281 9.33641 10.5922 9.02291C9.78022 8.54717 8.90682 8.29345 7.97161 8.19708C6.43137 8.0381 5.21845 7.31636 4.40644 5.98105C4.03642 5.37276 3.94656 4.72584 4.29991 4.06956C4.52314 3.65441 4.87079 3.35189 5.24609 3.0815C6.23701 2.36708 7.35153 1.93892 8.54331 1.71569C9.08329 1.61444 9.63425 1.57175 10.1803 1.50262C10.1824 1.51564 10.184 1.52865 10.186 1.54166L10.1864 1.54085ZM10.1864 2.09343C9.37564 2.10238 8.58235 2.22965 7.80694 2.46223C6.90954 2.73181 6.06054 3.10224 5.3388 3.715C5.15501 3.87114 4.97529 4.04639 4.84314 4.24563C4.50403 4.75674 4.61178 5.27273 4.91633 5.75416C5.63482 6.88982 6.68509 7.51153 8.01065 7.64368C9.01661 7.74412 9.9571 8.01817 10.8342 8.52196C11.8629 9.11318 12.918 9.1392 13.9813 8.62036C14.4774 8.37802 14.908 8.03688 15.1451 7.53105C15.583 6.59625 15.4358 5.68585 14.9267 4.82139C14.4929 4.0842 13.8634 3.53528 13.1767 3.04206C12.2813 2.3992 11.2871 2.08205 10.1864 2.09302V2.09343Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--              <path-->
                <!--                d="M6.80985 11.3505C6.81595 11.7831 6.72324 12.1987 6.60004 12.6089C6.53498 12.8261 6.46057 13.0407 6.39754 13.2587C6.2292 13.8389 5.82544 14.1492 5.24805 14.2382C4.50761 14.3525 3.79401 14.237 3.15725 13.8426C2.92955 13.7015 2.75715 13.4506 2.59857 13.2229C1.88456 12.1987 1.53325 11.0544 1.55886 9.80696C1.57513 9.0161 1.70809 8.23663 1.88903 7.46651C1.9484 7.21441 2.01264 6.96271 2.08461 6.71387C2.29361 5.9901 3.08244 5.7506 3.67324 6.2178C4.29699 6.71143 4.84713 7.27296 5.30538 7.92313C5.61685 8.36512 5.93726 8.80141 6.2292 9.256C6.63704 9.89113 6.80944 10.599 6.80944 11.3505H6.80985ZM6.25889 11.3273C6.25563 10.6922 6.1121 10.0794 5.75388 9.53901C5.37776 8.97178 4.98294 8.41594 4.57267 7.87271C4.21282 7.39616 3.77368 6.9924 3.29916 6.6297C3.03527 6.42802 2.71527 6.53658 2.61931 6.85374C2.6006 6.91555 2.58434 6.97857 2.56685 7.04078C2.31719 7.92801 2.14804 8.83231 2.11348 9.75248C2.06875 10.9467 2.41885 12.0344 3.11903 13.0042C3.22556 13.1518 3.33576 13.3262 3.48742 13.4055C4.05343 13.7015 4.65928 13.8076 5.29278 13.6588C5.51194 13.6076 5.71362 13.4978 5.79128 13.2815C6.01736 12.652 6.2536 12.0226 6.25848 11.3269L6.25889 11.3273Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--              <path d="M12.9173 5.14302C13.6768 5.14872 14.3071 5.78384 14.2945 6.5312C14.2814 7.29319 13.6508 7.91652 12.9022 7.90717C12.1439 7.89782 11.5149 7.26188 11.5258 6.51534C11.5372 5.7505 12.1589 5.13692 12.9173 5.14262V5.14302ZM13.739 6.52428C13.7402 6.06888 13.3723 5.69927 12.9156 5.69683C12.4578 5.69439 12.0898 6.05465 12.0809 6.51331C12.0719 6.96749 12.4562 7.3554 12.9124 7.35377C13.3625 7.35215 13.7378 6.97562 13.739 6.52428Z" fill="#373737" />-->
                <!--            </svg>-->
                <!--          </div>-->
                <!--          <div class="modifier__name">Конина</div>-->
                <!--        </div>-->
                <!--        <div class="modifiers__item modifier">-->
                <!--          <div class="modifier__icon">-->
                <!--            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--              <path-->
                <!--                d="M9.01344 12.6333C9.13614 12.8257 9.24376 12.994 9.35033 13.1633C9.37592 13.204 9.39905 13.2464 9.41869 13.2902C9.47407 13.4136 9.43797 13.5262 9.32824 13.5801C9.22377 13.6313 9.12036 13.5952 9.04885 13.4848C8.91879 13.2832 8.78452 13.0838 8.65727 12.8804C8.57454 12.7483 8.47848 12.6943 8.31197 12.7279C8.16649 12.7574 8.01014 12.7342 7.85308 12.7342C7.94423 12.988 8.02801 13.2212 8.11145 13.4543C8.12161 13.483 8.13073 13.5125 8.13704 13.5423C8.16298 13.6671 8.10864 13.7645 7.99506 13.7992C7.88569 13.8325 7.78332 13.7772 7.73775 13.6573C7.64766 13.421 7.56282 13.1823 7.46712 12.9484C7.43346 12.8661 7.38754 12.7458 7.32269 12.7272C7.16669 12.682 6.99632 12.6834 6.83155 12.6753C6.80666 12.6743 6.76985 12.7192 6.75443 12.7507C6.61561 13.0298 6.50413 13.3176 6.48099 13.6334C6.47118 13.7659 6.37828 13.8501 6.26014 13.8417C6.1434 13.8332 6.0456 13.7354 6.06803 13.6057C6.1094 13.3663 6.17425 13.1307 6.2321 12.8941C6.24542 12.8401 6.27136 12.7893 6.29555 12.7262C6.06873 12.7262 5.85244 12.7223 5.63614 12.7297C5.59688 12.7311 5.54745 12.7693 5.52291 12.8047C5.33852 13.0694 5.15868 13.3372 4.97884 13.6047C4.95465 13.6408 4.94133 13.6843 4.91609 13.7193C4.85194 13.8077 4.73766 13.835 4.64826 13.7796C4.55221 13.72 4.50313 13.6282 4.55747 13.5227C4.66159 13.3214 4.77832 13.1265 4.8912 12.9295C4.91469 12.8888 4.94309 12.8506 4.97744 12.7991C4.74502 12.8201 4.52943 12.8443 4.31313 12.8583C3.76135 12.8937 3.21307 12.8762 2.6683 12.7654C1.96753 12.6228 1.46904 12.1972 1.07536 11.6317C0.427873 10.702 0.366525 9.69103 0.689391 8.6369C0.981758 7.68267 1.57245 6.93037 2.30968 6.28008C2.98135 5.68798 3.73611 5.21122 4.47439 4.71097C4.78183 4.50239 5.08086 4.28189 5.38444 4.0677C5.80406 3.77147 6.08206 3.37464 6.22298 2.88245C6.30116 2.61007 6.3916 2.33838 6.43682 2.06004C6.46662 1.876 6.43647 1.67968 6.41439 1.49073C6.37618 1.16225 6.56302 0.910903 6.91499 0.837636C7.24031 0.769978 7.52812 0.934741 7.60875 1.24078C7.76755 1.84444 7.91934 2.45021 8.08305 3.05283C8.11285 3.16255 8.17174 3.27193 8.24186 3.36237C8.6166 3.84474 9.07128 4.24929 9.52315 4.65664C10.1075 5.18353 10.6972 5.70551 11.2714 6.24362C12.363 7.26726 12.7725 8.56117 12.7185 10.0237C12.6992 10.5446 12.58 11.0466 12.2905 11.4915C11.9077 12.0797 11.3331 12.3833 10.6656 12.4955C10.1762 12.5779 9.67495 12.5902 9.1789 12.6329C9.13193 12.6368 9.08425 12.6336 9.01414 12.6336L9.01344 12.6333ZM7.90041 12.3339C8.07464 12.3209 8.25062 12.3195 8.42239 12.2922C8.59382 12.2648 8.76664 12.2263 8.9293 12.1667C9.63533 11.908 10.0557 11.3737 10.253 10.6765C10.6432 9.29945 10.4493 7.97539 9.74926 6.74212C9.40747 6.13986 8.98399 5.58247 8.57874 5.01877C8.13423 4.40073 7.80401 3.73537 7.62417 2.99393C7.49446 2.45933 7.35178 1.92788 7.21437 1.39503C7.18176 1.26777 7.12041 1.22676 6.99842 1.24814C6.86661 1.27128 6.82279 1.33438 6.83646 1.46514C6.91323 2.195 7.01104 2.92347 7.05872 3.65544C7.12602 4.68503 6.98054 5.67992 6.54024 6.63204C6.22754 7.30862 5.96567 8.0101 5.70871 8.71016C5.50328 9.26966 5.37287 9.85124 5.37918 10.4531C5.389 11.3495 5.82054 11.9125 6.68081 12.1642C7.0787 12.2806 7.4864 12.3213 7.89971 12.3332L7.90041 12.3339ZM6.63173 3.11558C6.61946 3.11663 6.60719 3.11768 6.59528 3.11873C6.49992 3.32381 6.41088 3.53239 6.30817 3.73396C5.93657 4.46102 5.41774 5.07976 4.87087 5.67852C4.43758 6.15283 4.00148 6.62538 3.58887 7.11757C3.26075 7.50879 3.02026 7.95541 2.90633 8.46056C2.77382 9.04775 2.84814 9.62758 2.99012 10.199C3.24638 11.2286 3.84233 11.9444 4.90803 12.2052C5.2344 12.2852 5.56638 12.3143 5.93833 12.3136C5.87908 12.2687 5.85069 12.2452 5.82019 12.2245C5.40372 11.9395 5.14676 11.5458 5.03353 11.0575C4.89821 10.4721 4.96833 9.8926 5.09979 9.31768C5.30241 8.43217 5.64561 7.59538 6.0179 6.77157C6.36215 6.0091 6.64926 5.23611 6.644 4.38425C6.6412 3.96113 6.63559 3.53835 6.63138 3.11522L6.63173 3.11558ZM4.22444 12.4433C4.21918 12.4219 4.21953 12.4159 4.21708 12.4145C4.18728 12.3977 4.15468 12.3844 4.12698 12.3644C3.88965 12.1951 3.63129 12.0475 3.42095 11.8494C2.94384 11.4004 2.6953 10.8191 2.55577 10.1892C2.384 9.41339 2.33457 8.64075 2.64692 7.88284C2.86111 7.36296 3.18047 6.91004 3.55101 6.49392C4.00744 5.98105 4.47544 5.4787 4.93818 4.97144C4.96096 4.9462 4.97954 4.9171 5.00023 4.88976C4.84248 4.97319 4.7005 5.06749 4.55852 5.16179C3.82725 5.64907 3.08932 6.12689 2.44184 6.72775C1.84308 7.28338 1.36176 7.9186 1.10901 8.70596C0.843287 9.53398 0.831017 10.3536 1.26361 11.1315C1.58402 11.7075 2.01205 12.1761 2.69039 12.3406C3.19309 12.4622 3.7028 12.4647 4.22409 12.4433H4.22444ZM9.78467 12.1614C9.78713 12.1733 9.78958 12.1853 9.79203 12.1975C10.0718 12.159 10.355 12.1376 10.6302 12.0787C11.3657 11.9209 11.929 11.5423 12.1604 10.7883C12.2305 10.5604 12.2845 10.3203 12.2968 10.0833C12.3669 8.71192 11.9999 7.49477 10.9689 6.53669C10.2709 5.8878 9.55681 5.2568 8.84938 4.61808C8.84657 4.61562 8.8357 4.62158 8.81888 4.62649C9.09968 5.02052 9.37311 5.4156 9.65812 5.80227C10.5499 7.01205 10.9573 8.36276 10.8353 9.86351C10.7631 10.7529 10.4833 11.5543 9.78467 12.1614Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--            </svg>-->
                <!--          </div>-->
                <!--          <div class="modifier__name">Чеснок</div>-->
                <!--        </div>-->
                <!--        <div class="modifiers__item modifier">-->
                <!--          <div class="modifier__icon">-->
                <!--            <svg width="17" height="7" viewBox="0 0 17 7" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--              <path-->
                <!--                d="M0.910478 6V0.36H1.42248L4.82248 4.896V0.36H5.43048V6H4.93448L1.52648 1.448V6H0.910478ZM8.49635 6.072C7.88302 6.072 7.39769 5.89333 7.04035 5.536C6.68302 5.17333 6.50435 4.68267 6.50435 4.064C6.50435 3.664 6.58435 3.312 6.74435 3.008C6.90435 2.69867 7.12302 2.46133 7.40035 2.296C7.68302 2.12533 8.00835 2.04 8.37635 2.04C8.90435 2.04 9.31769 2.21067 9.61635 2.552C9.91502 2.888 10.0644 3.352 10.0644 3.944V4.192H7.13635C7.15769 4.63467 7.28569 4.97333 7.52035 5.208C7.75502 5.43733 8.08035 5.552 8.49635 5.552C8.73102 5.552 8.95502 5.51733 9.16835 5.448C9.38169 5.37333 9.58435 5.25333 9.77635 5.088L10.0004 5.544C9.82435 5.70933 9.60035 5.84 9.32835 5.936C9.05635 6.02667 8.77902 6.072 8.49635 6.072ZM8.39235 2.52C8.02435 2.52 7.73369 2.63467 7.52035 2.864C7.30702 3.09333 7.18169 3.39467 7.14435 3.768H9.50435C9.48835 3.37333 9.38435 3.06667 9.19235 2.848C9.00569 2.62933 8.73902 2.52 8.39235 2.52ZM11.9873 6L10.5393 2.112H11.2193L12.3153 5.24L13.4513 2.112H14.0033L15.1233 5.248L16.2353 2.112H16.8833L15.4273 6H14.8113L13.7153 2.984L12.6113 6H11.9873Z"-->
                <!--                fill="#373737"-->
                <!--              />-->
                <!--            </svg>-->
                <!--          </div>-->
                <!--          <div class="modifier__name">Новинка</div>-->
                <!--        </div>-->
                <!--      </div>-->
            </div>
            <div class="product__price-wrapper">
                <div class="product__price">{{ product.price }} ₽</div>
                <button class="product__btn-more" @click="productPopup">Подробнее</button>
            </div>
        </div>
    </article>
    <div class="mask" :class="isProductPopup ? `_popup` : ``" @click="productPopup">
        <div class="popup-up-menu" @click.stop>
            <div class="popup-up-menu__container">
                <div class="popup-up-menu__image">
                    <img :src="product.image" :alt="product.real_name" />
                </div>
                <div class="popup-up-menu__body">
                    <div class="popup-up-menu__head">
                        <h2 class="popup-up-menu__title">{{ product.real_name }}</h2>
                        <div class="popup-up-menu__ornament md">
                            <img src="../assets/images/ornament.png" alt="ornament" />
                        </div>
                        <div class="popup-up-menu__price">{{ product.price }} ₽</div>
                    </div>
                    <!--<div class="popup-up-menu__icons">
            <div class="icon">
              <div class="icon__img"><img src="../assets/images/icons/1.svg" alt="icons" /></div>
              <div class="icon__name">Острое</div>
            </div>
            <div class="icon">
              <div class="icon__img"><img src="../assets/images/icons/2.svg" alt="icons" /></div>
              <div class="icon__name">Чеснок</div>
            </div>
            <div class="icon">
              <div class="icon__img"><img src="../assets/images/icons/3.svg" alt="icons" /></div>
              <div class="icon__name">Лук</div>
            </div>
            <div class="icon">
              <div class="icon__img"><img src="../assets/images/icons/4.svg" alt="icons" /></div>
              <div class="icon__name">Конина</div>
            </div>
          </div>-->
                    <div class="popup-up-menu__text">{{ product.description }}</div>
                    <div class="popup-up-menu__ornament mm">
                        <img src="../assets/images/ornament.png" alt="ornament" />
                    </div>
                    <div class="popup-up-menu__comps">
                        <div class="cols">
                            <div class="cols__col">
                                <span class="cols__number">{{ product.weight !== 0 ? product.weight : `-` }}</span>
                                <span class="cols__dimens">грамм</span>
                            </div>
                            <!-- <div class="cols__col">
                <span class="cols__number">{{ product.energy !== 0 ? product.energy : `-` }}</span>
                <span class="cols__dimens">калории</span>
              </div>
              <div class="cols__col">
                <span class="cols__number">{{ product.proteins !== 0 ? product.proteins : `-` }}</span>
                <span class="cols__dimens">белки</span>
              </div>
              <div class="cols__col">
                <span class="cols__number">{{ product.fat !== 0 ? product.fat : `-` }}</span>
                <span class="cols__dimens">жиры</span>
              </div>
              <div class="cols__col">
                <span class="cols__number">{{ product.carbohydrates !== 0 ? product.carbohydrates : `-` }}</span>
                <span class="cols__dimens">углеводы</span>
              </div> -->
                        </div>
                    </div>
                </div>
                <div class="popup-up-menu__close" @click="productPopup">
                    <img src="../assets/images/svg/close_white.svg" alt="close" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "main-page-product",
    data() {
        return {
            isProductPopup: false,
        };
    },
    methods: {
        productPopup() {
            this.isProductPopup = !this.isProductPopup;
        },
    },
    props: ["product"],
};
</script>

<style lang="scss" scoped>
@font-face {
    font-family: "MontserratBold";
    src: url("../assets/fonts/Montserrat-Medium.woff2");
}
.product {
    box-shadow: 2px 2px 10px 0px #0000000d;

    width: 100%;
    height: auto;
    background-color: #fefefe;
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 20px;
    padding-bottom: 30px;
    overflow: hidden;
    @media (max-width: 1200px) {
        border-radius: 10px;
        padding-bottom: 16px;
    }
    @media (max-width: 768px) {
        width: 100%;
        flex: 1 1 auto;
        border-radius: 10px;
        padding-bottom: 16px;
    }
    &__body {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1 auto;
    }
    // .product__picture
    &__picture {
        height: 230px;
        position: relative;
    }

    // .product__img
    &__img {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height: 100%;
        border-radius: 10px 10px 0 0;
        cursor: pointer;
        @media (max-width: 768px) {
            background-size: cover;
        }
        @media screen and (min-width: 1440px) {
            border-radius: 20px 20px 0 0;
        }

        // .product__img::before
        &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
            background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);

            @media screen and (min-width: 1440px) {
                height: 80px;
            }
        }
    }

    // .product__content
    &__content {
        padding: 12px 9px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;

        @media screen and (min-width: 1440px) {
            padding: 17px 29px;
            row-gap: 14px;
        }
    }

    // .product__name
    &__name {
        font-family: "MontserratBold", sans-serif;
        font-size: clamp(14px, 5vw, 24px);
        line-height: 1.33;

        @media screen and (min-width: 1440px) {
            font-weight: 400;
            line-height: 1.36;
        }
        @media (max-width: 768px) {
            font-size: 16px;
            font-weight: 600;
        }
    }

    // .product__text
    &__text {
        font-family: "Montserrat", sans-serif;
        font-size: clamp(12px, 5vw, 12px);
        font-weight: 300;
        line-height: 1.2;
        @media screen and (min-width: 1440px) {
            line-height: 1.39;
        }
    }

    // .product__price-wrapper
    &__price-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 9px;
        @media screen and (min-width: 1440px) {
            padding: 0 29px;
        }
        // @media screen and (max-width: 480px) {
        //   flex-direction: column;
        // }
    }

    // .product__price
    &__price {
        font-family: "MontserratBold", sans-serif;
        font-size: clamp(14px, 5vw, 24px);
        font-weight: 600;
        line-height: 1.33;
        padding: 0;
        margin: 0;

        @media screen and (min-width: 1440px) {
            font-weight: 400;
            line-height: 1.36;
        }
        @media (max-width: 768px) {
            font-size: 16px;
            font-weight: 600;
        }
    }

    // .product__btn-more
    &__btn-more {
        font-family: "Montserrat", sans-serif;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.4;
        background-color: #2a374b;
        color: #ffffff;
        border: none;
        outline: none;
        cursor: pointer;
        border-radius: 12px;
        // width: auto;
        height: 40px;
        font-size: clamp(12px, 5vw, 18px);
        // margin-top: 10px;
        padding: 0 15px;
        &:hover,
        &:focus {
            background-color: #cf603f;
            transition: 0.2s ease 0.2s;
        }
        @media screen and (min-width: 1440px) {
            font-weight: 400;
            line-height: 1.35;
        }
        @media (max-width: 768px) {
            height: 24px;
            padding: 0 9px;
            border-radius: 12px;
            font-size: 8px;
        }
    }

    // .product__video
    &__video {
        position: absolute;
        bottom: 9px;
        right: 10px;

        @media screen and (min-width: 1440px) {
            bottom: 23px;
            right: 27px;
        }
    }

    // .product__modifiers
    &__modifiers {
        @media screen and (min-width: 1440px) {
            margin: 10px 0;
        }
    }
}
.product ~ .mask {
    @media (max-width: 768px) {
        align-items: flex-end;
    }
}
.video {
    display: flex;
    column-gap: 4px;
    cursor: pointer;

    @media screen and (min-width: 1440px) {
        column-gap: 10px;
    }

    // .video__text
    &__text {
        font-family: "Montserrat", sans-serif;
        font-size: 8px;
        font-weight: 600;
        line-height: 1.375;
        color: #ffffff;

        @media screen and (min-width: 1440px) {
            font-size: 14px;
            line-height: 1.35;
        }
    }

    // .video__btn
    &__btn {
        width: 12px;
        height: 12px;
        border-radius: 50px;
        background-color: #ffffff;
        border: none;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (min-width: 1440px) {
            width: 18px;
            height: 18px;

            & svg {
                width: 10px;
                height: 10px;
            }
        }
    }
}
.modifiers {
    display: flex;
    column-gap: 14px;
}
.modifier {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    align-items: center;

    @media screen and (min-width: 1440px) {
        row-gap: 8px;
    }

    // .modifier__icon
    &__icon {
        width: 22px;
        height: 22px;
        border: 1px solid #373737;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (min-width: 1440px) {
            width: 36px;
            height: 36px;
        }
    }

    // .modifier__name
    &__name {
        font-family: "Montserrat", sans-serif;
        font-size: 6px;
        font-weight: 600;
        line-height: 1.33;

        @media screen and (min-width: 1440px) {
            font-size: 14px;
            font-weight: 400;
            line-height: 1.35;
        }
    }
}
.popup-up-menu {
    background-color: #fff;
    border-radius: 10px;
    padding: 0;
    width: 100%;
    max-width: 512px;
    height: fit-content;
    @media (max-width: 768px) {
        border-radius: 10px 10px 0 0;
        height: 75vh;
    }
    &__head {
        display: flex;
        justify-content: space-between;
    }
    &__ornament {
        width: 62px;
        height: 12px;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            filter: brightness(0.5);
        }
        @media (max-width: 768px) {
            margin: 20px -5px 0;
        }
    }
    &__close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
        width: 20px;
        height: 20px;
        &:hover,
        &:focus {
            filter: invert(0.5);
            transition: 0.2s ease 0.2s;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__price {
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #2a374b;
    }
    &__container {
        display: flex;
        position: relative;
        flex-direction: column;
    }
    &__image {
        width: 100%;
        height: 400px;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        @media (max-width: 768px) {
            height: 284px;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__body {
        padding: 30px;
        display: flex;
        flex-direction: column;
        @media (max-width: 768px) {
            width: 100%;
            margin: 0 auto;
            padding: 20px;
        }
    }
    &__title {
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #2a374b;
    }
    &__icons {
        display: flex;
    }
    &__text {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #0d0d0d;
        margin-top: 20px;
        @media (max-width: 768px) {
            margin-top: 10px;
        }
    }
    &__comps {
        margin-top: 20px;
    }
    .icon {
        margin: 2rem 2rem 0px 0px;
        @media (max-width: 479px) {
            margin: 1rem 1rem 0px 0px;
        }
        &__img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #a07f56;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (max-width: 360px) {
                width: 24px;
                height: 24px;
                img {
                    width: 15px;
                }
            }
        }
        &__name {
            font-family: "Montserrat", sans-serif;
            color: #373737;
            line-height: clamp(13.64px, 5vw, 27.28px);
            font-size: clamp(10px, 5vw, 20px);
            margin-top: 5px;
        }
    }
    .cols {
        width: 100%;
        height: 100%;
        &__col {
            display: flex;
            flex-direction: column;
        }
        &__number {
            font-weight: 600;
            color: #2a374b;
            font-size: 14px;
            line-height: 24px;
        }
        &__dimens {
            font-weight: 400;
            font-size: 10px;
            line-height: 16px;
            color: #5a5a5a;
        }
    }
}
</style>
